const initialState = {
    bookId: undefined
}

export default initialState;